import React, { useState, useEffect, useRef } from 'react';
import { useQuery, useMutation } from 'react-query';
import { api } from 'api';
import { useSelector } from 'react-redux';
import { loggedInUserSelector } from 'redux/selectors';
import { showSnackbar } from 'components/snackbar/actions';
import { snackbarTypes } from 'constants/index';
import { useDispatch } from 'react-redux';
export default function useAddContacts({
  worksheetCollectionId,
  type,
  fileName,
  selectedAssociates,
  setSelectedAssociates,
}) {
  const [selectedItems, setSelectedItems] = useState([]);
  const formikRef = useRef();
  const [emailData, setEmailData] = useState([]);
  const [message, setMessage] = useState('');
  const [subject, setSubject] = useState('');
  // state to get input value
  const [emailInput, setEmailInput] = useState('');
  const [pdfTitle, setPdfTitle] = useState('');
  const [editorValue, setEditorValue] = useState([]);
  const [edit, setEdit] = useState(false);
  // send emails
  const [sendingEmails, setSendingEmails] = useState(false);
  const [emailResponses, setEmailResponses] = useState([]);
  const [emailsSent, setEmailsSent] = useState(0);
  const [index, setIndex] = useState(0);

  const user = useSelector(loggedInUserSelector);
  const dispatch = useDispatch();
  const getPdfDataQuery = useQuery({
    queryKey: ['PdfData'],
    queryFn: () => getPdfData(),
  });
  const getPdfData = async () => {
    const res = await api.get(
      `order/getDataForOrderPdfEmail/${worksheetCollectionId}?type=${type}`
    );

    if (res.data.status) {
      setEmailData(res?.data?.data?.contactsData);
      return res?.data?.data;
    }
    return {};
  };

  useEffect(() => {
    if (getPdfDataQuery?.data?.formData) {
      let pdfTitle =
        type == 'invoice'
          ? fileName
          : getPdfDataQuery?.data?.formData?.pdfTitle;

      setPdfTitle(pdfTitle);
      setMessage(getPdfDataQuery?.data?.formData?.message);
      setSubject(getPdfDataQuery?.data?.formData?.subject);
      setEdit(true);
    }
  }, [getPdfDataQuery?.data]);
  useEffect(() => {
    if (getPdfDataQuery?.data?.contactsData) {
      setEmailData(getPdfDataQuery?.data?.contactsData);
    }
  }, [getPdfDataQuery?.data]);

  const onSubmitFormikHandler = (values) => {
    let payload = {
      email: values.email,
    };
    addContacts.mutate(payload);
  };
  // Add Contacts
  const addContacts = useMutation({
    mutationFn: (payload) => {
      return api.post('order/addContacts', payload);
    },
    onSuccess: (data) => {
      console.log('data', data);
      if (data.data.status) {
        setEmailData((prev) => {
          return [
            {
              id: data?.data?.data?.id,
              contact_email: data?.data?.data?.contact_email,
            },
            ...prev,
          ];
        });
        setSelectedItems((prev) => {
          return [
            ...prev,
            {
              id: data?.data?.data?.id,
              contact_email: data?.data?.data?.contact_email,
            },
          ];
        });
      } else {
        dispatch(
          showSnackbar({
            snackbarMessage: data?.data?.message ?? 'Somthing went wrong',
            type: snackbarTypes.ERROR,
          })
        );
      }

      // getPdfDataQuery.refetch();
    },
  });
  //=================> query to send email <================================================
  const sendEmailQuery = useMutation({
    mutationFn: () => {
      return api.post('order/sendOrderPdfEmail', {
        worksheet_collection_id: worksheetCollectionId,
        receipent_contact_id: selectedItems[index].id,
        receipent_rep_assoc_ids: (() => {
          let AssociatesId = [];
          if (index == 0) {
            if (selectedAssociates.length > 0) {
              selectedAssociates.forEach((value) => {
                AssociatesId.push(value.id);
              });
            }
          }
          return AssociatesId.length > 0 ? AssociatesId : '';
        })(),
        subject: subject,
        message: message,
        filename: pdfTitle,
        type: type,
        oldFileName: fileName ? fileName : '',
      });
    },
    onSuccess: (data) => {
      if (data.status) {
        setEmailResponses([
          ...emailResponses,
          {
            recipientId: selectedItems[index]?.id,
            recipientName: selectedItems[index]?.contact_email,
            recipientEmail: selectedItems[index]?.contact_email,
            status: data.status ? 'sent' : 'failed',
            type: 'buyer',
          },
        ]);
        setEmailsSent(emailsSent + 1);
      }
      setIndex((index) => index + 1);
    },
  });
  useEffect(() => {
    if (index > 0 && index < selectedItems.length) sendEmailQuery.mutate();
  }, [index]);
  // ======================> Remove Email ID <=========================================
  const deleteEmailQuery = useMutation({
    mutationFn: () => {
      return api.delete('order/removeContacts', {
        data: {
          ids: (() => {
            let updatedArray = [];
            selectedItems.forEach((item) => {
              updatedArray.push(parseInt(item.id));
            });
            return updatedArray;
          })(),
        },
      });
    },
    onSuccess: (data) => {
      getPdfDataQuery.refetch();
      setSelectedItems([]);
    },
  });

  return {
    selectedItems,
    setSelectedItems,
    onSubmitFormikHandler,
    emailData,
    setEmailData,
    emailInput,
    setEmailInput,
    pdfTitle,
    setPdfTitle,
    getPdfDataQuery,
    formikRef,
    subject,
    setSubject,
    message,
    setMessage,
    editorValue,
    setEditorValue,
    edit,
    setEdit,
    sendingEmails,
    setSendingEmails,
    emailsSent,
    emailResponses,
    sendEmailQuery,
    deleteEmailQuery,
    user,
  };
}
